module.exports = __webpack_public_path__ + "static/img/deviceMonitor.63c29a96.jpg";